import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Check, X } from 'lucide-react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { ProductGridTestIds } from '../../../../../../../utils/testIds/productGrid.testIds';
import { CopyOrPasteStatusEnum } from '../../../../../../orders/products/product/components/copy-paste/copyPaste.types';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { useCombinationPasteStateButtonStyles } from './combinationPasteStateButton.styles';

export interface CombinationPasteStateButtonProps {
  pasteStatus: CopyOrPasteStatusEnum;
  isPasteBlockedByPacks?: boolean;
  onClickPaste: () => void;
  onClearCopiedGrid: () => void;
}

const CombinationPasteStateButton = ({
  pasteStatus,
  isPasteBlockedByPacks,
  onClickPaste,
  onClearCopiedGrid,
}: CombinationPasteStateButtonProps) => {
  const { translate } = useTranslation();
  const { classes, cx } = useCombinationPasteStateButtonStyles();

  if (pasteStatus === CopyOrPasteStatusEnum.ON_COPY_SELECTED) {
    return (
      <Button
        variant="outlined"
        shape="square"
        tabIndex={-1}
        className={cx(classes.base, classes.copiedButton)}
        endIcon={<Icon icon={X} size="xs" />}
        onClick={onClearCopiedGrid}
      >
        {translate(LangEnum.ORDER_PRODUCTS_GRID_STATUS_COPIED)}
      </Button>
    );
  }

  if (pasteStatus === CopyOrPasteStatusEnum.ON_PASTED_GRID) {
    return (
      <Button
        disabled
        variant="contained"
        shape="square"
        tabIndex={-1}
        className={cx(classes.base, classes.pastedButton)}
        startIcon={<Icon icon={Check} size="xs" />}
      >
        {translate(LangEnum.ORDER_PRODUCTS_GRID_STATUS_PASTED)}
      </Button>
    );
  }

  if (pasteStatus === CopyOrPasteStatusEnum.ON_PASTE_ACTION && !isPasteBlockedByPacks) {
    return (
      <Button
        variant="contained"
        shape="square"
        tabIndex={-1}
        testId={ProductGridTestIds.GRID_PASTE_BUTTON}
        className={cx(classes.base, classes.pasteButton)}
        onClick={onClickPaste}
      >
        {translate(LangEnum.ORDER_PRODUCTS_GRID_STATUS_TO_PASTED)}
      </Button>
    );
  }

  return (
    <Tooltip TooltipContent={translate(LangEnum.ORDER_PRODUCTS_GRID_STATUS_INCOMPATIBLE)}>
      <Button
        disabled
        variant="outlined"
        shape="square"
        tabIndex={-1}
        className={cx(classes.base, classes.invalidButton)}
      >
        {translate(LangEnum.GLOBAL_INVALID)}
      </Button>
    </Tooltip>
  );
};

export default CombinationPasteStateButton;
